import ApiService from "./ApiService";

const MaintenanceService = {
    getMaintenaceInfo() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/maintenance').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    }
};

export default MaintenanceService
